export enum I9IntelligencePostMessageActionEnum {
  ready = 'ready',
  logoff = 'logoff',
  s1complete = 's1complete',
}

export enum I9VerificationMethodEnum {
  InPerson = 'In Person',
  VideoCall = 'Video Call',
}

export enum I9StatusesEnum {
  I9NotNeeded = 1,
  Required = 2,
  PendingSection1 = 3, // SECTION_1_INITIATED
  PendingSection2 = 4, // SECTION_1_SIGNED, SECTION_2_INITIATED
  CompletedSection2 = 5,
  SubmittedToEVerify = 6,
  EVerifyAuthorized = 7, // I9_COMPLETED
  EVerifyNotAuthorized = 8, // I9_COMPLETED
  PendingReview = 9,
  PendingSection1Revision = 10,
  PendingSection2Revision = 11,
  ProcessManually = 12,
  Expired = 13,
  Pending_EVerify = 14, // SECTION_2_SIGNED
  Terminated = 15, // TERMINATED
  Deleted = 16, // DELETED
  Errored = 17, // i9 Intelligence outage when outage flag is off
  Section1SignedInOT = 18, // Temporary status when employee has successfully completed Section 1
  Section2SignedInOT = 19, // Temporary status when manager completes Section 2
}

export interface II9Info {
  text: string | null;
  status: I9StatusesEnum | null;
  sectionOneUrl: string | null;
  isSectionOneCompleted: boolean | null;
  isI9Intelligence?: boolean | null;
}
